export const config = 
[
    {
        "env": "dev",
        "name": "Smu-Dev",
        "config": {
            "url": "apply-smims.smu.edu.in",
            "apiBaseUrl": "https://smims-admissions-prod-api.ken42.com/api/",
            "tokenUrl": "https://az-token-dev.ken42.com/v1/azure/token",
            "logoURL": "https://inazstgpfs3001.blob.core.windows.net/assets/flame/flamelogo1.png"
        },
        "id": "674c727c78db1db1e5647980"
    }
]